import { Injectable } from '@angular/core';
import { HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { 
  ODataClient,
  ODataEntityService, 
  ODataEntity, 
  ODataEntities, 
  ODataProperty, 
  EntityKey,
  Duration,
  ODataEntityResource,
  ODataEntitySetResource,
  ODataNavigationPropertyResource,
  ODataActionResource,
  ODataFunctionResource,
  HttpOptions
} from 'angular-odata';

//#region ODataApi Imports
import { Artikel } from '../entities/artikel.entity';
import { Hersteller } from '../entities/produkte/hersteller.entity';
//#endregion

@Injectable()
export class HerstellerService extends ODataEntityService<Hersteller> {
  constructor(protected client: ODataClient) {
    super(client, 'Hersteller', 'entities.produkte.Hersteller');
  }

  
  
  //#region ODataApi Actions
  //#endregion
  //#region ODataApi Functions
  //#endregion
  //#region ODataApi Navigations
  public articles(entity: EntityKey<Hersteller>): ODataNavigationPropertyResource<Artikel> {
    return this.entity(entity).navigationProperty<Artikel>('articles');
  }
  //#endregion
}
